module.exports = __webpack_public_path__ + "media/images/icons/ic-map-user-marker-a7b2809e2ce0f23ac9a8e1d6a5a23118.svg";